import styled from 'styled-components';

const PolicyWrapper = styled.div`
.viewSample {
    display: none;
}
.viewMore {

     svg {
        width: 32px;
        height: 32px;
    }
}
`;
const SelectedPolicy = styled.div`
`;
const Styled = { SelectedPolicy, PolicyWrapper };
export default Styled;
